import WebApi from "@/views/loyalty/shared/modules/web_api"

export class AccountEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/account/`
        this.url2 = `${process.env.VUE_APP_LOYALTY_URL}api/accounts/`
        this.webApi = new WebApi()
    }

    async create_account (customer_number) {
        const campaign_accounts = await this.webApi.get(`${this.url}customer/${customer_number}`)
        if (!campaign_accounts.status_code) {
            return campaign_accounts
        } else {
            console.error(`Ошибка с кодом: ${campaign_accounts.status_code}`)
        }
    }

    async create_participant_account_balance (accountParticipantBalance) {
        const account = await this.webApi.post(`${this.url}participant/balance`, accountParticipantBalance)
        if (!account.status_code) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }

    async change_emission_account (accountRead) {
        const account = await this.webApi.put(`${this.url}`, accountRead)
        if (!account.status_code) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }

    async correction_account (correctionAccount) {
        const account = await this.webApi.put(`${this.url}correction`, correctionAccount)
        if (account.status_code === 200) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }

    async change_participant_account_balance (account_participant_debit) {
        const account = await this.webApi.put(`${this.url}/participant/debit`, account_participant_debit)
        if (!account.status_code) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }

    async create_account_for_new_participant (participant_id, customers_participant) {
        const accounts = await this.webApi.post(`${this.url2}${participant_id}`, customers_participant)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async get_accrual (campaign_id) {
        const accounts = await this.webApi.get(`${this.url}accrual/${campaign_id}`)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async get_accrual_account (customer_id, participant_id) {
        const accounts = await this.webApi.get(`${this.url}customer_participant/${customer_id}/${participant_id}`)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async get_all_customer_accounts () {
        const accounts = await this.webApi.get(`${this.url2}customer/all`)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async get_all_campaign_customer_accounts (campaign_id, customer_number) {
        const accounts = await this.webApi.get(`${this.url2}customer/${campaign_id}/${customer_number}`)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async get_emission_account (campaign_id) {
        const accounts = await this.webApi.get(`${this.url}emission/${campaign_id}`)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async get_participant_account (campaignId, participant_id) {
        const account = await this.webApi.get(`${this.url}campaign_participant/${campaignId}/${participant_id}`)
        if (!account.status_code) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }

    async get_participant_accounts (participant_id) {
        const account = await this.webApi.get(`${this.url}participant/${participant_id}`)
        if (!account.status_code) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }

    async get_participants_accounts_by_customer_and_participant (customer_id, participant_id) {
        const accounts = await this.webApi.get(`${this.url}customer_participant/${customer_id}/${participant_id}`)
        if (!accounts.status_code) {
            return accounts
        } else {
            console.error(`Ошибка с кодом: ${accounts.status_code}`)
        }
    }

    async participant_cashin (campaign_id, participant_id, amount) {
        await this.webApi.put(`${this.url}participant/cashin/${campaign_id}/${participant_id}`, { amount: amount })
    }

    async update_amount (account_update) {
        const account = await this.webApi.put(`${this.url}update`, account_update)
        // console.log('account update', account)
        if (account.status_code === 200) {
            return account
        } else {
            console.error(`Ошибка с кодом: ${account.status_code}`)
        }
    }
}
